import { Stack, Typography } from "@mui/material";
import DebtReportIcon from "src/assets/img/debt-report.svg";

const DebtReportItem = ({ item: { title, description, type }, onClick }) => {
  const handleClick = () => {
    onClick(type);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        height: "100px",
        minWidth: "460px",
        width: "100%",
        bgcolor: "var(--light-grey)",
        borderRadius: "6px",
        p: "17px",
        boxSizing: "border-box",
        cursor: "pointer",
      }}
      onClick={handleClick}
    >
      <img
        src={DebtReportIcon}
        alt="debt-report"
      />
      <Stack spacing={1}>
        <Typography
          variant="h6"
          fontWeight="bold"
          fontSize="16px"
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          fontSize="14px"
          whiteSpace="pre-line"
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default DebtReportItem;
